import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import DataTable from "react-data-table-component";
import moment from "moment";
import ItemService from "../../../../services/supplier_appCommonService";

const SendMailModal = ({ show, onHide, rfxNr, rfxTitle, closingDateTime }) => {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [title, setTitle] = useState("");
  useEffect(() => {
    if (show && rfxNr) {
      loadSuppliers();
    }
    // eslint-disable-next-line
  }, [show, rfxNr]);

  const loadSuppliers = async () => {
    setLoading(true);
    try {
      const res = await ItemService.getRfxDocumentDetail({
        documentNumber: rfxNr,
      });
      if (res?.status === 200) {
        const list = (res?.data?.supplierList || []).filter(
          (s) => s?.qtnSupplierStatus !== "QTN Received",
        );
        setSuppliers(list);
        setTitle(res?.data?.rfxTitle || "");
      }
    } catch (err) {
      toast.error("Failed to load supplier data", { position: "top-right" });
    }
    setLoading(false);
  };

  const handleSendMail = async () => {
    if (suppliers.length === 0) {
      toast.error("No suppliers with quotation to send reminder", {
        position: "top-right",
      });
      return;
    }

    setSending(true);
    const payload = {
      suppliers: suppliers.map((s) => ({
        email: s.email,
        rfqNumber: rfxNr,
        title: title,
        company: "Atila",
        deadline: closingDateTime || "",
      })),
    };

    const toastId = toast.loading("Sending reminders...", {
      position: "top-right",
    });
    try {
      const res = await ItemService.sendRfqReminder(payload);
      if (res?.status === 200) {
        toast.success(res?.message || "Emails sent successfully", {
          position: "top-right",
        });
        onHide();
      } else {
        toast.error(res?.message || "Failed to send emails", {
          position: "top-right",
        });
      }
    } catch (err) {
      toast.error("Something went wrong", { position: "top-right" });
    }
    toast.dismiss(toastId);
    setSending(false);
  };

  const columns = [
    {
      name: "Supplier ID",
      selector: (row) => row.AssociateNumber || "--",
      width: "120px",
    },
    {
      name: "Name",
      selector: (row) => row.organisationName || "--",
      width: "180px",
    },
    {
      name: "Email",
      selector: (row) => row.email || "--",
      width: "220px",
    },
  ];

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Send Reminder</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-3">
          <Col xs={12} md={6} lg={6}>
            <strong>RFQ Number:</strong> {rfxNr}
          </Col>
          <Col xs={12} md={6} lg={6}>
            <strong>Title:</strong> {title || "--"}
          </Col>
        </Row>
        <Row className="mb-3">
          <Col xs={12} md={6} lg={6}>
            <strong>Company:</strong> Atila
          </Col>
          <Col xs={12} md={6} lg={6}>
            <strong>Deadline:</strong>{" "}
            {closingDateTime
              ? moment(closingDateTime, "YYYY-MM-DD HH:mm").format("DD-MM-YYYY HH:mm")
              : "--"}
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {" "}
            <h2>{`Suppliers to Remind (${suppliers.length})`}</h2>
          </Col>
          <Col xs={12}>
            <DataTable
              title=""
              columns={columns}
              data={suppliers}
              pagination
              paginationRowsPerPageOptions={[5, 10, 20]}
              progressPending={loading}
              noDataComponent="No suppliers found with QTN Received status"
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Row className="w-100 d-flex justify-content-end">
          <Col sm={4} md={4} lg={4}>
            <button className="btnTable btn-danger" onClick={onHide}>
              <i className="bi bi-x-circle me-1"></i> Cancel
            </button>
          </Col>
          <Col sm={4} md={4} lg={4}>
            <button
              className="btnTable"
              onClick={handleSendMail}
              disabled={sending || suppliers.length === 0}
            >
              <i className="bi bi-envelope me-1"></i>{" "}
              {sending ? "Sending..." : "Send Mail"}
            </button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};

export default SendMailModal;
